import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
} from "@mui/material";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import { VOID_TAKE_OUT } from "../../Schema/TakeOut";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";

export default function VoidTakeOut({
  setRefetch,
  open,
  handleClose,
  title,
  editData,
}) {
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [voidReqTakeOut] = useMutation(VOID_TAKE_OUT, {
    onCompleted: ({ voidReqTakeOut }) => {
      setLoading(false);
      if (voidReqTakeOut?.status === true) {
        setAlert(true, "success", voidReqTakeOut?.message);
        setRefetch();
        handleClose();
        resetForm();
      } else {
        setAlert(true, "error", voidReqTakeOut?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
      setLoading(false);
    },
  });

  //formik
  const CheckValidation = Yup.object().shape({
    remark: Yup.string(),
  });
  const formik = useFormik({
    initialValues: {
      remark: "",
    },

    validationSchema: CheckValidation,
    onSubmit: (values) => {
      setLoading(true);
      voidReqTakeOut({
        variables: {
          // voidReqTakeOutId2v:editData?._id,
          id: editData?._id,
          remark: values?.remark,
        },
      });
    },
  });
  // console.log("veditDateditData", editData)

  const { handleSubmit, getFieldProps, setFieldValue, values, resetForm } =
    formik;
  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="xs">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">មោឃៈ{title}</Typography>
            {/* <Typography className="dialog-title">{t(`header-delete-${title}`)}</Typography> */}
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography className="delete-descript">
              តើអ្នកពិតជាចង់ធ្វើមោឃៈទិន្នន័យនេះមែនទេ?
            </Typography>
          </Grid>
        </Grid>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography className="field-title">ចំណាំ</Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder="ចំណាំ"
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  className="btn-delete"
                  fullWidth
                  onClick={loading ? null : handleSubmit}
                >
                  {loading ? "កំពុងដំណើរការ..." : "មោឃៈ"}
                </Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
